import cn from "classnames";
import st from './equipment.module.scss';
import Heading from "@pages/partners/items/uralchem/components/heading/Heading";
import uralchemBuchi from "@images/partners/uralchem/equipment-buchi.png";
import uralchemShimadzu from "@images/partners/uralchem/equipment-shimadzu.png";
import React, { FC } from "react";

interface EquipmentProps {
    className: string
}
const Equipment: FC<EquipmentProps> = ({className}) => {
    return (
        <section className={cn(className, st['equipment'])}>
            <Heading.Section>Оборудование</Heading.Section>
            <p className={st['equipment__general-description']}>В агролаборатории «УРАЛХИМ» все анализы проводят
                с помощью <b>нового высококачественного и точного оборудования от ведущих мировых
                    производителей</b></p>
            <p className={st['equipment__list-threshold']}>{'Основными локомотивами при проведении анализов служат: '}</p>
            <div className={st['equipment__content']}>
                <div className={st['equipment__content-column']}>
                    <div className={st['equipment__description']}>
                        <p>Система озоления и отгонки швейцарской фирмы <b>BUCHI</b> для проведения анализа на
                            содержание общего азота и белка в растениях</p>
                        <p>{'Она позволяет значительно сократить трудозатраты и время на анализ по сравнению с классическим методом отгонки по Къельдалю'}</p>
                    </div>
                    <img width={576} src={uralchemBuchi} alt={'buchi'}/>
                </div>
                <div className={st['equipment__content-column']}>
                    <img width={576} src={uralchemShimadzu} alt={'shimadzu'}/>
                    <div className={st['equipment__description']}>
                        <p>Спектрометр с индуктивно-связанной плазмой японской фирмы <b>SHIMADZU</b> для
                            определения содержания металлов</p>
                        <p>{'Это спектрометр последнего поколения, оптический блок находится в постоянном вакууме, что позволяет точно определять даже самые низкие концентрации элементов в пробах'}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Equipment;